import { useState } from 'react';
import { Container, Row, Col, Accordion, Badge } from 'react-bootstrap';
import { AnimatePresence, motion } from 'framer-motion';

const ItemHeader = ({ children }: { children: React.ReactNode }) => (
  <Accordion.Header className="bg-white text-white fw-semibold">
    {children}
  </Accordion.Header>
);

const specialties = [
  'Preventive Nutrition',
  'Health at Every Size®',
  'Intuitive Eating',
  'Gastrointestinal',
  'Cancer',
  'Pediatric & Adolescents',
  'Food Allergies & Intolerances',
  'Eating Disorders',
  'Cardiovascular Health',
  'Sustainable Weight Loss',
  'Diabetes Management',
  'etc...',
];

const ServicesSection = () => {
  const [activeKey, setActiveKey] = useState<string | null>(null);

  const getImageSrc = () => {
    switch (activeKey) {
      case '0':
        return '/images/bird_views/video-tutorial.webp';
      case '1':
        return '/images/bird_views/team-presentation.webp';
      case '2':
        return '/images/bird_views/doctor.webp';
      case '3':
        return '/images/bird_views/steps.webp';
      default:
        return '/images/bird_views/content-tornado.webp';
    }
  };

  return (
    <section className="py-5 bg-light-subtle">
      <Container>
        <Row className="align-items-center">
          <Col md={4}>
            <h2 className="fw-bold mb-4">Services</h2>
            <AnimatePresence mode="wait">
              <div
                style={{ height: '350px' }}
                className="d-flex align-items-center justify-content-center"
              >
                <motion.img
                  key={activeKey}
                  src={getImageSrc()}
                  alt="Illustration representing services"
                  className="img-fluid"
                  initial={{ opacity: 0, x: -64 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 64 }}
                  transition={{ duration: 0.5 }}
                />
              </div>
            </AnimatePresence>
          </Col>
          <Col md={8}>
            <Accordion
              activeKey={activeKey}
              onSelect={(k) => setActiveKey(k as string | null)}
              flush
            >
              <Accordion.Item eventKey="0">
                <ItemHeader>Personal Nutrition Counseling</ItemHeader>
                <Accordion.Body>
                  <h6 className="fw-bold mb-3">Provider Specialties:</h6>
                  <Row xs={1} sm={2} md={3} className="g-2">
                    {specialties.map((item, index) => (
                      <Col key={index}>
                        <Badge
                          bg="light"
                          text="black"
                          className="w-100 py-2 px-3 text-start shadow-sm"
                        >
                          {item}
                        </Badge>
                      </Col>
                    ))}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <ItemHeader>Corporate Wellness</ItemHeader>
                <Accordion.Body>
                  Our comprehensive program not only promotes health and
                  productivity among your team but also ensures their well-being
                  is taken care of, fostering a more energized and focused
                  workforce.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <ItemHeader>Medical Clinic Partnerships</ItemHeader>
                <Accordion.Body>
                  Enhance healthcare collaboration by bridging silos with our
                  services, facilitating teamwork among healthcare professionals
                  and dietitians. This direct line of communication ensures that
                  every decision made is informed by comprehensive data,
                  allowing for adjustments that are in the best interest of the
                  patient's health.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <ItemHeader>Diabetes Management</ItemHeader>
                <Accordion.Body>
                  Our providers offer expert support for diabetes management,
                  including Certified Diabetes Care and Education Specialists
                  (CDCES). They’ll help you understand your condition, make
                  sustainable nutrition changes, and stay on track with your
                  health goals.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;
